import { render, staticRenderFns } from "./public-dialogue.vue?vue&type=template&id=4a9d6116&scoped=true&"
import script from "./public-dialogue.vue?vue&type=script&lang=js&"
export * from "./public-dialogue.vue?vue&type=script&lang=js&"
import style0 from "./public-dialogue.vue?vue&type=style&index=0&id=4a9d6116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9d6116",
  null
  
)

export default component.exports